import React, { FC } from "react";
import { Container, Grid } from "@mui/material";
import IngredientListTable from "components/food/ui/ingredientList/IngredientListTable";
import BottomSpacedPageHeader from "components/common/ui/BottomSpacedPageHeader";
import CommonButton from "components/common/ui/CommonButton";
import { useNavigate } from "react-router-dom";
import Routes from "models/routes";

interface IngredientListPageProps {}

const IngredientListPage: FC<IngredientListPageProps> = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <BottomSpacedPageHeader>Ingredients</BottomSpacedPageHeader>
      <CommonButton
        onClick={() => {
          navigate(`${Routes.FOOD_UPDATE_SUPPLIER_INFO_BY_INVOICE}`, {
            replace: false,
          });
        }}
        text="Upload invoice"
        positive
      />
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <IngredientListTable />
        </Grid>
      </Grid>
    </Container>
  );
};

export default IngredientListPage;
